<dx-popup
  [showTitle]="true"
  [title]="'Remarque permanente — ' + selectedUdpSf?.fournisseurLibelle + ' (' + selectedUdpSf?.secteurLibelle + ')'"
  [(visible)]="displayDialog"
  [width]="'22vw'"
  [height]="'auto'"
  [shading]="true"
  [deferRendering]="false"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>
  <dx-text-area
    [value]="remarqueCommande"
    (valueChange)="remarqueCommande = $event"
    [maxLength]="250"
    [disabled]="!canWrite"
    [height]="120"
  ></dx-text-area>

  <div class="d-flex justify-content-end mg-t-10">
    <span class="mg-r-5" *ngIf="canWrite">
      <yo-button (onClick)="saveRemarque()" iconClass="fas fa-save" [theme]="ButtonThemeEnum.SAVE"></yo-button>
    </span>
    <yo-button iconClass="fas fa-times"
               [theme]="ButtonThemeEnum.CANCEL"
               (onClick)="closeDialog()">
    </yo-button>
  </div>
</dx-popup>
